/**
 * @format
 * @Description: 消息事件请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';
import Cookie from 'js-cookie';
import { isArray } from 'lodash';
export default class HeaderBarServ {
  static logout(params) {
    return Request({
      url: `api/identity/v3/user/${Cookie.get('user_id')}/token`,
      method: 'delete'
    });
  }

  static getUser() {
    return Request({
      url: `api/user/v1/user/${Cookie.get('user_id')}`,
      method: 'get'
    });
  }

  static getUserOrg() {
    return Request({
      url: `api/user/v2/employee/current-login-user`,
      method: 'get'
    });
  }
  
  static getMessageCount(params) {
    return Request({
      method: 'get',
      url: `api/message/v1/message/list`,
      data:{
        pageNum: 1,
        pageSize: 10,
        filter: {
          send_status: 1,
          status: '0',
          targets: Cookie.get('user_id'),
        }
      }
    });
  }
  static updatePwd({data}) {
    return Request({
      url: `security/user-password`,
      method: 'PUT',
      data,
      app: 'user',
      version: 'v1',
  });
  }
  
}



// WEBPACK FOOTER //
// ./src/widget/HeaderBar/HeaderBarServ.js